export default __webpack_public_path__ + "static/media/tete89.b19b06d3.png";